export const slidePDF = pdfjsLib => {
    document.querySelectorAll(".pdf__container").forEach((el, key) => {
        el.id = `container_${key}`;
        if (document.querySelectorAll(".pdf__container")[key].dataset.filetype === "pdf") {
            let _PDF_DOC,
                _TOTAL_PAGES,
                _CURRENT_PAGE = 1;

            const _CANVAS = document.querySelector(`#container_${key} .pdf__canvas`),
                _PAGES_CONT = document.querySelectorAll(".pdf__pages")[key],
                _CURRENT = document.querySelectorAll(".pdf__currentPage")[key],
                _LOADER = document.querySelector(`#container_${key} .pdf__loader`),
                _FULLSCREEN = document.querySelectorAll(".pdf__fullScreen")[key],
                _NEXT_IMG = document.querySelectorAll(".pdf__nextImg")[key],
                _PREVIOUS_IMG = document.querySelectorAll(".pdf__prevImg")[key],
                _NEXT = document.querySelectorAll(".pdf__next")[key],
                _PREVIOUS = document.querySelectorAll(".pdf__prev")[key],
                _PDF_LIST = document.querySelectorAll(".pdf__ul")[key],
                _DRAWER = document.querySelector(`#container_${key} .pdf__drawerToggle`),
                _PDF_PREVIEW = document.querySelectorAll(".pdf__list")[key],
                _PDF_CONTENT = document.querySelectorAll(".pdf__content")[key];

            const firstPDF = _PDF_LIST.dataset.url;

            const setWidth = () => {
                if (Array.prototype.slice.call(_PDF_CONTENT.classList).indexOf("pdf__content--full") === -1) {
                    if (_CANVAS.clientHeight > _CANVAS.clientWidth) {
                        _CANVAS.style.height = "100%";
                        _CANVAS.style.width = "auto";
                    } else {
                        _CANVAS.style.height = "auto";
                        _CANVAS.style.width = "100%";
                    }
                }
            };

            const setPages = pdf_url => {
                const allList = Array.prototype.slice.call(_PDF_LIST.children);

                allList.forEach((pdf, key) => {
                    const preview = pdf.children[0];

                    const pdfDoc = pdfjsLib.getDocument({ url: pdf_url }).promise;
                    pdfDoc.then(pdfFile => {
                        pdfFile.getPage(key + 1).then(page => {
                            let ctx = preview.getContext("2d");

                            let viewport = page.getViewport(1);
                            preview.width = viewport.width;
                            preview.height = viewport.height;

                            page.render({
                                canvasContext: ctx,
                                viewport: viewport
                            });
                        });
                    });

                    pdf.onclick = function() {
                        _CURRENT_PAGE = key + 1;
                        showPage(_CURRENT_PAGE);

                        if (_CURRENT_PAGE === 1) {
                            _PREVIOUS_IMG.style.display = "none";
                        }

                        if (_CURRENT_PAGE < _TOTAL_PAGES) _NEXT_IMG.style.display = "block";

                        if (_CURRENT_PAGE === _TOTAL_PAGES) {
                            _NEXT_IMG.style.display = "none";
                        }

                        if (_CURRENT_PAGE > 1) _PREVIOUS_IMG.style.display = "block";

                        allList.forEach(item => {
                            item.classList.remove("pdf__item--active");
                        });

                        this.classList.add("pdf__item--active");
                    };
                });
            };

            const showPDF = async pdf_url => {
                try {
                    _PDF_DOC = await pdfjsLib.getDocument({ url: pdf_url }).promise;
                } catch (error) {
                    alert(error.message);
                }

                _TOTAL_PAGES = _PDF_DOC.numPages;

                if (_TOTAL_PAGES === 1) {
                    document.querySelector(`#container_${key} .pdf__pageCounter`).style.display = "none";
                    document.querySelectorAll(`#container_${key} .pdf__btn`).forEach(el => {
                        el.style.display = "none";
                    });
                }

                _PAGES_CONT.innerHTML = _TOTAL_PAGES;

                if (_TOTAL_PAGES === 1) {
                    _NEXT_IMG.style.display = "none";
                    _PREVIOUS_IMG.style.display = "none";
                } else {
                    _PREVIOUS_IMG.style.display = "none";
                    _NEXT_IMG.style.display = "block";
                }

                let listTemp = "";

                for (let key = 0; key < _TOTAL_PAGES; key += 1) {
                    listTemp += `
                    <li class="pdf__item ${key === 0 ? "pdf__item--active" : ""}">
                        <canvas class="pdf__previewCanvas" width="1000"></canvas>
                    </li>`;
                }

                _PDF_LIST.innerHTML = listTemp;

                setPages(pdf_url);

                showPage(_CURRENT_PAGE);
            };

            const showPage = async page_no => {
                _CURRENT_PAGE = page_no;

                _CANVAS.style.display = "none";
                _LOADER.style.display = "block";

                _CURRENT.innerHTML = page_no;

                try {
                    var page = await _PDF_DOC.getPage(page_no);
                } catch (error) {
                    alert(error.message);
                }

                let pdf_original_width = page.getViewport(1).width;

                let scale_required = _CANVAS.width / pdf_original_width;

                let viewport = page.getViewport(scale_required);

                _CANVAS.height = viewport.height;

                _LOADER.style.height = _CANVAS.height + "px";
                _LOADER.style.lineHeight = _CANVAS.height + "px";

                let render_context = {
                    canvasContext: _CANVAS.getContext("2d"),
                    viewport: viewport
                };

                try {
                    await page.render(render_context);
                } catch (error) {
                    alert(error.message);
                }

                _CANVAS.style.display = "inline-block";
                _LOADER.style.display = "none";

                if (_DRAWER) {
                    if (!_DRAWER.classList.contains("show")) {
                        if (window.innerWidth > 1024) {
                            _CANVAS.style.height = "100%";
                            _CANVAS.style.width = "auto";
                        }
                    } else {
                        setWidth();
                    }
                } else {
                    setWidth();
                }
            };

            showPDF(firstPDF);

            _PREVIOUS.addEventListener("click", function() {
                const allList = Array.prototype.slice.call(_PDF_LIST.children);
                if (_CURRENT_PAGE > 1) {
                    _CURRENT_PAGE -= 1;
                    showPage(_CURRENT_PAGE);

                    if (_CURRENT_PAGE === 1) {
                        _PREVIOUS_IMG.style.display = "none";
                    }

                    if (_CURRENT_PAGE < _TOTAL_PAGES) _NEXT_IMG.style.display = "block";

                    allList.forEach(item => {
                        item.classList.remove("pdf__item--active");
                    });

                    allList[_CURRENT_PAGE - 1].classList.add("pdf__item--active");
                }
            });

            _NEXT.addEventListener("click", function() {
                const allList = Array.prototype.slice.call(_PDF_LIST.children);
                if (_CURRENT_PAGE < _TOTAL_PAGES) {
                    _CURRENT_PAGE += 1;
                    showPage(_CURRENT_PAGE);

                    if (_CURRENT_PAGE === _TOTAL_PAGES) {
                        _NEXT_IMG.style.display = "none";
                    }

                    if (_CURRENT_PAGE > 1) _PREVIOUS_IMG.style.display = "block";

                    allList.forEach(item => {
                        item.classList.remove("pdf__item--active");
                    });

                    allList[_CURRENT_PAGE - 1].classList.add("pdf__item--active");
                }
            });

            _FULLSCREEN.onclick = function() {
                const grand = this.parentNode;

                this.classList.toggle("full");

                if (this.classList.contains("full")) {
                    this.children[0].style.display = "none";
                    this.children[1].style.display = "block";
                    grand.classList.add("pdf__content--full");

                    if (window.innerWidth > 1024) {
                        _CANVAS.style.height = "100%";
                        _CANVAS.style.width = "auto";
                    }

                    document.querySelector("body").style.overflowY = "hidden";
                    document.querySelector(".page").style.zIndex = 11;
                    if (_DRAWER) _DRAWER.style.display = "none";
                } else {
                    this.children[1].style.display = "none";
                    this.children[0].style.display = "block";
                    grand.classList.remove("pdf__content--full");

                    document.querySelector("body").style.overflowY = "auto";
                    document.querySelector(".page").style.zIndex = 1;
                    if (_DRAWER) _DRAWER.style.display = "block";
                }

                if (_DRAWER) {
                    if (!_DRAWER.classList.contains("show")) {
                        if (window.innerWidth > 1024) {
                            _CANVAS.style.height = "100%";
                            _CANVAS.style.width = "auto";
                        }
                    } else {
                        setWidth();
                    }
                } else {
                    setWidth();
                }
            };

            if (_DRAWER) {
                _DRAWER.onclick = function() {
                    this.classList.toggle("show");
                    const event = this.classList.contains("show") ? "add" : "remove";

                    if (window.innerWidth > 1024) _PDF_CONTENT.style.width = this.classList.contains("show") ? "70%" : "100%";

                    _PDF_PREVIEW.classList[event]("pdf__list--show");

                    if (!this.classList.contains("show")) {
                        if (window.innerWidth > 1024) {
                            _CANVAS.style.height = "100%";
                            _CANVAS.style.width = "auto";
                        }
                    } else {
                        setWidth();
                    }
                };
            }
        } else {
            const _PDF_UL = document.querySelectorAll(".pdf__ul")[key],
                _PDF_ITEM = _PDF_UL.children,
                _DRAWER = document.querySelector(`#container_${key} .pdf__drawerToggle`),
                _PDF_IMG = document.querySelector(`#container_${key} .pdf__infoGraphic`),
                _PDF_PREVIEW = document.querySelectorAll(".pdf__list")[key],
                _PDF_CONTENT = document.querySelectorAll(".pdf__content")[key],
                _PDF_LOADER = document.querySelector(`#container_${key} .pdf__infoGraphicLoader`),
                _PDF_PAGES = document.querySelectorAll(".pdf__pages")[key],
                _PDF_CURRENT = document.querySelectorAll(".pdf__currentPage")[key],
                _FULLSCREEN = document.querySelectorAll(".pdf__fullScreen")[key],
                _NEXT_IMG = document.querySelectorAll(".pdf__nextImg")[key],
                _PREVIOUS_IMG = document.querySelectorAll(".pdf__prevImg")[key],
                _NEXT = document.querySelectorAll(".pdf__next")[key],
                _PREVIOUS = document.querySelectorAll(".pdf__prev")[key];

            let _CURRENT_PAGE = 1;

            let _TOTAL_PAGES = _PDF_ITEM.length;
            _PDF_PAGES.innerHTML = _TOTAL_PAGES;
            _PDF_CURRENT.innerHTML = _CURRENT_PAGE;

            if (_TOTAL_PAGES === 1) {
                document.querySelector(`#container_${key} .pdf__pageCounter`).style.display = "none";
                document.querySelectorAll(`#container_${key} .pdf__btn`).forEach(el => {
                    el.style.display = "none";
                });
            }

            const firstImg = _PDF_ITEM[0].dataset.url;
            _PDF_ITEM[0].classList.add("pdf__item--active");
            _PDF_IMG.setAttribute("src", firstImg);
            _PDF_LOADER.style.display = "none";
            _PDF_IMG.style.display = "block";

            if (_TOTAL_PAGES === 1) {
                _NEXT_IMG.style.display = "none";
                _PREVIOUS_IMG.style.display = "none";
            } else {
                _PREVIOUS_IMG.style.display = "none";
                _NEXT_IMG.style.display = "block";
            }

            if (_DRAWER) {
                _DRAWER.onclick = function() {
                    this.classList.toggle("show");
                    const event = this.classList.contains("show") ? "add" : "remove";

                    if (window.innerWidth > 1024) _PDF_CONTENT.style.width = this.classList.contains("show") ? "70%" : "100%";

                    _PDF_PREVIEW.classList[event]("pdf__list--show");
                };
            }

            if (_PDF_ITEM) {
                let pdfItem = Array.from(_PDF_ITEM);

                pdfItem.forEach((el, key) => {
                    el.onclick = function() {
                        _PDF_ITEM.forEach(item => {
                            item.classList.remove("pdf__item--active");
                        });

                        _CURRENT_PAGE = key + 1;

                        _PDF_CURRENT.innerHTML = _CURRENT_PAGE;
                        this.classList.add("pdf__item--active");
                        _PDF_IMG.setAttribute("src", this.dataset.url);

                        if (_CURRENT_PAGE === _TOTAL_PAGES) {
                            _NEXT_IMG.style.display = "none";
                        }

                        if (_CURRENT_PAGE > 1) _PREVIOUS_IMG.style.display = "block";

                        if (_CURRENT_PAGE === 1) {
                            _PREVIOUS_IMG.style.display = "none";
                        }

                        if (_CURRENT_PAGE < _TOTAL_PAGES) _NEXT_IMG.style.display = "block";
                    };
                });
            }

            _NEXT.onclick = function() {
                if (_CURRENT_PAGE < _TOTAL_PAGES) _CURRENT_PAGE += 1;
                const item = _PDF_ITEM[_CURRENT_PAGE - 1];

                _PDF_ITEM.forEach(item => {
                    item.classList.remove("pdf__item--active");
                });

                item.classList.add("pdf__item--active");
                _PDF_IMG.setAttribute("src", item.dataset.url);
                _PDF_CURRENT.innerHTML = _CURRENT_PAGE;

                if (_CURRENT_PAGE === _TOTAL_PAGES) {
                    _NEXT_IMG.style.display = "none";
                }

                if (_CURRENT_PAGE > 1) _PREVIOUS_IMG.style.display = "block";

                document.querySelector(`#container_${key} .pdf__infoGraphicHolder`).scrollTop = 0;
            };

            _PREVIOUS.onclick = function() {
                if (_CURRENT_PAGE > 1) _CURRENT_PAGE -= 1;
                const item = _PDF_ITEM[_CURRENT_PAGE - 1];

                _PDF_ITEM.forEach(item => {
                    item.classList.remove("pdf__item--active");
                });

                item.classList.add("pdf__item--active");
                _PDF_IMG.setAttribute("src", item.dataset.url);
                _PDF_CURRENT.innerHTML = _CURRENT_PAGE;

                if (_CURRENT_PAGE === 1) {
                    _PREVIOUS_IMG.style.display = "none";
                }

                if (_CURRENT_PAGE < _TOTAL_PAGES) _NEXT_IMG.style.display = "block";

                document.querySelector(`#container_${key} .pdf__infoGraphicHolder`).scrollTop = 0;
            };

            _FULLSCREEN.onclick = function() {
                const grand = this.parentNode;

                this.classList.toggle("full");

                if (this.classList.contains("full")) {
                    this.children[0].style.display = "none";
                    this.children[1].style.display = "block";
                    grand.classList.add("pdf__content--full");

                    document.querySelector("body").style.overflowY = "hidden";
                    document.querySelector(".page").style.zIndex = 11;
                    if (_DRAWER) _DRAWER.style.display = "none";
                } else {
                    this.children[1].style.display = "none";
                    this.children[0].style.display = "block";
                    grand.classList.remove("pdf__content--full");

                    document.querySelector("body").style.overflowY = "auto";
                    document.querySelector(".page").style.zIndex = 1;
                    if (_DRAWER) _DRAWER.style.display = "block";
                }
            };
        }
    });
};
